import { render, staticRenderFns } from "./Companions.vue?vue&type=template&id=6f87d12a&lang=pug&"
import script from "./Companions.vue?vue&type=script&lang=js&"
export * from "./Companions.vue?vue&type=script&lang=js&"
import style0 from "./Companions.vue?vue&type=style&index=0&id=6f87d12a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports